export const set = (state, action) => {
  return { ...state, responsiveState: action.payload };
};
